'use client';
import React from 'react';
import { cn } from '@/utils/common';
import styles from './Styles.module.scss';
import Image from 'next/image';
import Footer from '@/components/Shared/Footer';

interface Props {
  children: React.ReactNode;
}

export const AuthWrapper = ({ children }: Props) => {
  return (
    <div
      className={cn(
        'relative h-screen overflow-hidden',
        styles.authBackgrounds,
      )}
    >
      <div className={cn('grid grid-cols-1 lg:grid-cols-5 h-full')}>
        <div className={cn('hidden lg:block col-span-3 h-full')}>
          <div
            className={cn(
              'h-full flex flex-col items-center justify-center',
              styles.authBackground,
            )}
          >
            <div
              className={cn(
                styles.authContent,
                'flex flex-col items-start justify-center',
              )}
            >
              {/* <h1 className="font-extralight text-primary text-8xl">
                {AppName}
              </h1> */}
              <Image
                src="/images/logo.svg"
                alt="logo"
                width={200}
                height={200}
              />
              <div className=" mb-24 mt-6 mx-0 p-0">
                <p className="font-extralight uppercase text-[#938F8F] text-xs">
                  in partnership with
                </p>
                <Image
                  src="/images/partners.svg"
                  alt="background"
                  width={200}
                  height={200}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={cn(
            'col-span-2 flex flex-col items-start justify-center w-full px-4 md:px-0',
          )}
        >
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default AuthWrapper;
